import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CommonService } from '../services/common.service';

@Component({
  selector: 'via-referral-header',
  imports: [CommonModule],
  template: `
    <span class="via-referral-header">
      <span class="cursor-pointer" (click)="copyCaseNumber()">
        <span [ngClass]="{ 'text-base': size === 'small' }">ID: </span>
        <span
          [ngClass]="{ 'text-lg': size === 'small' }"
          class="color-primary font-medium"
        >
          {{ caseNumber }}
        </span>
      </span>
    </span>
  `,
  styles: [
    `
      .via-referral-header {
        display: block;
        font-size: 1.2rem;
        font-weight: 700;
      }
    `,
  ],
  standalone: true,
})
export class OReferralHeaderComponent {
  @Input() caseNumber!: string;
  @Input() size: 'small' | 'large' = 'large';

  constructor(private commonService: CommonService) {}

  copyCaseNumber() {
    navigator.clipboard.writeText(this.caseNumber);
    this.commonService.showToast('Success', 'ID copied to clipboard!');
  }
}
